export default "https://cdn-static.gokick.com/assets/81b7a47639310ad105c767144326fc68b25cbb5d/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";